
import { checkoutStore, cobrancaStore, companyStore, mainStore, reestruturacaoOcorrenciaStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import DataTableComponent from '@/components/DataTableComponent.vue';
import CompanyParticularitiesView from '@/components/CompanyParticularitiesView.vue';
import Ocorrencia from './ocorrencia/Ocorrencia.vue';
import CompanyDetailsView from '@/components/CompanyDetailsView.vue';
import DetailsInvoice from '@/views/main/invoice/DetailsOld.vue';
import ShowPopup from '@/components/ShowPopup.vue';
import api from '@/api';
import List2 from '@/views/main/financeiro/List2.vue';
import EntidadeLinkComponent from '@/components/EntidadeLinkComponent.vue';
import Create from '../checkout/Create.vue';

@Component({
  components: {
    DataTableComponent,
    Ocorrencia,
    CompanyDetailsView,
    ShowPopup,
    DetailsInvoice,
    CompanyParticularitiesView,
    List2,
    EntidadeLinkComponent,
    Create,
  },
})
export default class ReestruturacaoList extends Vue {
  public companyId = 0;
  public c014_id = 0;
  public tituloDetails = [];
  public invoiceSelectedId = 0;
  public company: any = {};

  public checkoutsComercial = [];
  public checkoutsFinanceiro = [];
  public checkoutsPedagogico = [];
  public checkoutsRetencao = [];

  public headerReestruturacao = [
    {
      text: 'c014_Id',
      sortable: true,
      value: 'c014_id',
      align: 'left',
    },
    {
      text: 'Unidade',
      sortable: true,
      value: 'unidade',
      align: 'left',
    },
    {
      text: 'UF',
      sortable: true,
      value: 'uf',
      align: 'left',
    },
    {
      text: 'CNPJ',
      sortable: true,
      value: 'cnpj',
      align: 'left',
    },
    {
      text: 'Franqueado',
      sortable: true,
      value: 'franqueado',
      align: 'left',
    },
    {
      text: 'Ultimo pedido atendido',
      sortable: true,
      value: 'ultimo_pedido_atendido',
      align: 'left',
    },
    {
      text: 'Pedido pendente aprovação',
      sortable: true,
      value: 'pedido_pendente_aprovacao',
      align: 'left',
    },
    {
      text: 'Deve desde',
      sortable: true,
      value: 'devedesde',
      align: 'left',
    },
    {
      text: 'Dias devendo',
      sortable: true,
      value: 'dias_devendo',
      align: 'left',
    },
    {
      text: 'Valor em atraso - KNN BRASIL',
      sortable: true,
      value: 'valor_em_atraso_knn_brasil',
      align: 'left',
    },
    {
      text: 'Valor em atraso - FUNDO DE PROP',
      sortable: true,
      value: 'valor_em_atraso_fundo_de_prop',
      align: 'center',
    },
    {
      text: 'Valor em atraso - PF',
      sortable: true,
      value: 'valor_em_atraso_pf',
      align: 'left',
    },
    {
      text: 'Situação financeira',
      sortable: true,
      value: 'situacao_financeiro',
      align: 'left',
    },
    {
      text: 'Status cobrança',
      sortable: true,
      value: 'status_cobranca',
      align: 'left',
    },
    {
      text: 'Condição pagamento',
      sortable: true,
      value: 'condicao_pgto',
      align: 'left',
    },
    {
      text: 'Próximo contato',
      sortable: true,
      value: 'data_proximo_contato',
      align: 'left',
    },
    {
      text: 'Responsável pelo contato',
      sortable: true,
      value: 'created_by_name',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'left',
    },
  ];

  public headerInvoice = [
    {
      text: 'Número do pedido',
      sortable: true,
      value: 'numero_pedido',
      align: 'left',
    },
    {
      text: 'Emissão',
      sortable: true,
      value: 'data_emissao',
      align: 'left',
    },
    {
      text: 'Valor',
      sortable: true,
      value: 'valor_negociado',
      align: 'left',
    },
    {
      text: 'Transportadora',
      sortable: true,
      value: 'observacao',
      align: 'left',
    },
    {
      text: 'Situação do Pedido',
      sortable: true,
      value: 'situacao_pedido',
      align: 'left',
    },
    {
      text: 'Visualizar',
      value: 'actions',
      align: 'center',
    },
  ];

  public loading = false;
  public showDetails = false;

  get reestruturacao() {
    return reestruturacaoOcorrenciaStore.companyReestruturacao;
  }

  get details() {
    return cobrancaStore.cobrancaDetails;
  }

  async updateCheckout(checkoutId: number) {
    const currentCheckout = await checkoutStore.getCheckoutsByFilter({
      company_id: this.company.id,
      checkout_id: [checkoutId],
    });
    this.checkoutsComercial = {
      ...this.checkoutsComercial,
      ...currentCheckout,
    };
    this.checkoutsFinanceiro = {
      ...this.checkoutsFinanceiro,
      ...currentCheckout,
    };
    this.checkoutsPedagogico = {
      ...this.checkoutsPedagogico,
      ...currentCheckout,
    };
    this.checkoutsRetencao = {
      ...this.checkoutsRetencao,
      ...currentCheckout,
    };
  }

  public showInvoice(item) {
    this.invoiceSelectedId = item.id;

    if (Object.keys(item).includes('tipo_pedido')) {
    } else {
    }

    let form: any = this.$refs.showDetailsInvoice;
    form.show();
  }

  public async handleShowCompanyReestruturacao(item) {
    this.showDetails = true;

    this.c014_id = item.c014_id;

    setTimeout(() => {
      const el: any = this.$refs.scrollInto;
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
      });
    }, 300);

    this.company = item;
    this.companyId = item.companyId;

    await cobrancaStore.getAceleracaoCobrancaDetails(item.c014_id);
    //@ts-ignore
    this.unidadeDetails = await companyStore.getCompanyByC014_id(item.c014_id);

    let checkoutsFinanceiro: any = Array(await checkoutStore.getCheckoutById(84));
    checkoutsFinanceiro = checkoutsFinanceiro.map((c) => c.id);
    this.checkoutsFinanceiro = await checkoutStore.getCheckoutsByFilter({
      company_id: this.company.id,
      checkout_id: checkoutsFinanceiro,
    });

    let checkoutsComercial: any = Array(await checkoutStore.getCheckoutById(85));
    checkoutsComercial = checkoutsComercial.map((c) => c.id);
    this.checkoutsComercial = await checkoutStore.getCheckoutsByFilter({
      company_id: this.company.id,
      checkout_id: checkoutsComercial,
    });

    let checkoutsPedagogico: any = Array(await checkoutStore.getCheckoutById(86));
    checkoutsPedagogico = checkoutsPedagogico.map((c) => c.id);
    this.checkoutsPedagogico = await checkoutStore.getCheckoutsByFilter({
      company_id: this.company.id,
      checkout_id: checkoutsPedagogico,
    });

    let checkoutsRetencao: any = Array(await checkoutStore.getCheckoutById(87));
    checkoutsRetencao = checkoutsRetencao.map((c) => c.id);
    this.checkoutsRetencao = await checkoutStore.getCheckoutsByFilter({
      company_id: this.company.id,
      checkout_id: checkoutsRetencao,
    });

    this.showDetails = false;
  }

  public async baixarBoleto(item) {
    try {
      const response = await api.getCompanyBoletos(mainStore.token, item);
      if (response) {
        const bytes = response.data;

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement('a');

        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', `${item.Documento}.pdf`);

        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank');
        }
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setTimeout(() => {
          window.URL.revokeObjectURL(blobURL);
        }, 100);
      }
    } catch (e) {
      await mainStore.checkApiError(<any>e);
    }
  }

  public async handleShowTituloDetails(item) {
    if (item.value) {
      this.tituloDetails = await cobrancaStore.getCobrancaTituloDetalhes(item.item.t014_id_parcela);
    }
  }

  public async mounted() {
    this.loading = true;

    await reestruturacaoOcorrenciaStore.getCompaniesInReestruturacao();

    this.loading = false;
  }
}
